<script setup lang="ts">
import { onErrorCaptured, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import ErrorState from '@/components/ui/ErrorState.vue'

const { t } = useI18n()
const failed = ref(false)
const detail = ref('')

onErrorCaptured((error) => {
  failed.value = true
  detail.value = error instanceof Error ? error.message : String(error)
  console.error('[app] render error', error)
  return false
})
</script>

<template>
  <ErrorState
    v-if="failed"
    :title="t('states.errorTitle')"
    :message="detail || t('states.errorHint')"
    @retry="failed = false"
  />
  <slot v-else />
</template>
